import DOMPurify from "dompurify";
import React, { useEffect } from "react";

import { useTicketingContext } from "../../store";

const InfoParagraph = () => {
  const { state } = useTicketingContext();

  const { steps } = state.texts;
  const { active: activeStep } = state.stepper;

  const error_message = state.appData?.config?.texts?.error_message;

  let description, title;

  useEffect(() => {
    document.title = `${steps[activeStep]?.stepper_label} - Home of Carlsberg`;

    if (window.dataLayer) {
      window.dataLayer.push({
        event: "virtual_page_view",
      });
    }
  }, [activeStep]);

  if (activeStep === 3) {
    title = steps[activeStep]?.personal_info[0]?.title;
    description = steps[activeStep]?.personal_info[0]?.description;
  } else {
    title = steps[activeStep]?.title;
    description = steps[activeStep]?.description;
  }
  return (
    <div className={`info-paragraph info-paragraph--step-${activeStep}`}>
      {title && <p className="info-paragraph-title">{title}</p>}
      {error_message && error_message !== "" ? (
        <p className="error-msg-backend">{error_message}</p>
      ) : null}
      {(description || []).map((part, index) => {
        return (
          <p
            key={index}
            className="info-paragraph-description"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(part) }}
          />
        );
      })}
    </div>
  );
};

export default React.memo(InfoParagraph);
